import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose } from '@nobia/zeus-components/lib/recompose'
import { gql, graphql } from '@nobia/zeus-components/lib/apollo'

const productQuery = gql`
  query ProductQuery($productId: String) {
    product(saveId: $productId) {
      id
      name
      slug
      images
      price
      saveId
      category {
        id
        nameSingular
      }
    }
  }
`

class ProductData extends Component {
  state = {
    error: false,
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.data.product) {
      if (
        this.props.data.product === null ||
        nextProps.data.product.id !== this.props.data.product.id // new product has been fetched
      ) {
        this.setState({ error: false })
        this.props.onProductFetch(nextProps.data.product)
      }
    } else if (nextProps.productToFetch !== '' && !nextProps.error) {
      this.setState({ error: true })
      this.props.onError()
    } else if (nextProps.error) {
      // console.log('error state update from parent: this.props.error: ', nextProps.error)
    }
  }

  render() {
    return (
      <div>
        {this.props.data.loading && <p>loading...</p>}
        {this.props.data.product && (
          <p>
            {this.props.productToFetch}: {this.props.data.product.name}
          </p>
        )}
        {this.state.error === true && (
          <div>
            <p>Product not found: {this.props.productToFetch}</p>
          </div>
        )}
      </div>
    )
  }
}

ProductData.propTypes = {
  productToFetch: PropTypes.string.isRequired,
  onProductFetch: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  error: PropTypes.bool.isRequired,
  data: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    product: PropTypes.object,
  }).isRequired,
}

const enhanced = compose(
  graphql(productQuery, {
    options: ({ productToFetch }) => ({
      variables: {
        productId: productToFetch,
      },
    }),
  })
)

export default enhanced(ProductData)
